// import   { useState } from 'react';
import './App.css';
import { Anchor,  Box,   Grommet,   Nav, Stack, StatusType, ThemeContext,} from 'grommet'
import {  Notification  as Toast } from 'grommet'
import {  Home, Notification, ChatOption, Paypal, Group, History} from 'grommet-icons'
import { Link, Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import { Component } from 'react';
import Dashboard from './pages/Dashboard';
import NewInvoice from './pages/NewInvoice';

export interface IAppProps {
	//Here we pass the Props Interface
}

export interface IAppState {
	//here we pass the State Interface
 userData : any,
  location : string
  isLoggedIn : boolean
  online : boolean
  mobile : boolean
  toastTitle : string,
  toastMessage : string,
  toastType : StatusType,
  toastVisible : boolean
}



//class ComponentName Component<PropsInterface, StateInterface>
class App extends Component<IAppProps, IAppState> {

  constructor(props:IAppProps){
		super(props)

 

		this.state = {
      userData : {},
      location : "/login",
		  isLoggedIn : false,
      online : true,
      mobile : false,
      toastTitle : "",
      toastMessage : "",
      toastType : "normal",
      toastVisible : false
		}
	}

// const [showMessage, setShowMessage] = useState(false)
redirectTo(link : string){
   this.setState({location:link})
}
  

safeRedirectTo(link:string){
  if(this.state.isLoggedIn === true){
    this.redirectTo(link)
  }else{
    this.redirectTo("/login")
  }
}

setToast(title : string , status : StatusType, message : string, visible : boolean){
  this.setState({toastTitle : title,toastMessage : message, toastType : status , toastVisible : visible})
}



 handleConnection(thisContext : any){
  if (navigator.onLine) {
    this.isReachable(window.location.origin).then(function(online) {
      if (online) {
        // handle online status
        thisContext.setState({online:true})
      } else {
        console.log('no connectivity');
      }
    });
  } else {
    // handle offline status
    console.log('offline');
  }
}


  isReachable(url: RequestInfo) {
 
  return fetch(url, { method: 'HEAD', mode: 'no-cors' })
    .then(function(resp) {
      return resp && (resp.ok || resp.type === 'opaque');
    })
    .catch(function(err) {
      console.warn('[conn test failure]:', err);
    });
}



setUserLoggedIn(input : boolean, username : string){
  this.setState({isLoggedIn:input, userData : {username : username}})
 
  if(input == true){
    // GET USER DATA


    this.redirectTo("/")
  }
}

componentDidMount(){
  
  window.addEventListener('online', this.handleConnection);
  window.addEventListener('offline', this.handleConnection);

  var isMobile = false; //initiate as false
// device detection
//@ts-nocheck
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
    isMobile = true;
    this.setState({mobile:true})
    
}else{
  this.setState({mobile : false})
  this.setToast("Ειδοποίηση","warning", "η εφαρμογη προορίζεται για χρήση μέσω Smartphone" , true)
}
 

  if (!('indexedDB' in window)) {
    console.log('This browser doesn\'t support IndexedDB');
    return;
  }else{
    console.log("WE HAVE INDEXEDDB")
  }

  if(this.state.isLoggedIn != true){
    this.redirectTo("/login")
  }else{
    this.redirectTo("/")
  }
  
}

render(){
return (
<Grommet>
  <ThemeContext.Extend value={ { global: { colors: {brand:  "#011627",accent1 : "red",  blue: '#1481BA' , green : "#6fffb0" , white : "#FAFFFD" , black : "#222725" , dark : "#011627" , purple : "#40376E" } } } }>

    {this.state.location == "/login" ? "" :
    <Nav direction="row" background="dark" pad="medium" align='center' justify='evenly'>
      <Anchor icon={<Home />} onClick={()=>this.safeRedirectTo("/")} color={ this.state.location=="/" ? "white" : "green"} className='hover' />
      
      <Anchor icon={<Group color={"green"} onClick={()=>this.safeRedirectTo("/")} />} />
      <Anchor icon={<History color={"green"} onClick={()=>this.safeRedirectTo("/")} />} />
      
     
      <Anchor icon={<ChatOption color={"green"} onClick={()=>this.safeRedirectTo("/")} />} />
     
    </Nav>
    }


    <Routes location={this.state.location}>
      {/* <Route path={this.state.location}/> */}

      <Route path="/"  element={<Dashboard redirectTo={(link:string)=>{this.safeRedirectTo(link)}} userData={this.state.userData}/>} />
      <Route path="/login" element={<Login setUserLoggedIn={(i:boolean, u:string)=>this.setUserLoggedIn(i,u)}/>} />
      <Route path="/invoices" >
        <Route path="/invoices/new" element={<NewInvoice setToast={(title: any,status : StatusType, message: any,show: any)=>{this.setToast(title,status, message , show)}}/>}/>
        </Route>
    </Routes>
    {this.state.location == "/" || this.state.location =="/login" ? 
      <p style={{textAlign: "center"}}>v.0.0.1</p> 
    :""}
     {this.state.toastVisible && (
      <Toast
        toast
        status={this.state.toastType}
        title={this.state.toastTitle}
        message={this.state.toastMessage}
        onClose={() => this.setToast("","unknown","",false)}
      />
    )}
  </ThemeContext.Extend>
</Grommet>
);
}
}

export default App;